import Header from './header';
import NavLinks from './navLinks';
import ListOrders from './listOrders';
import CCListOrders from './listClickAndCollecctOrders';

export { Header, NavLinks, ListOrders, CCListOrders}